(function (angular) {
  'use strict';

  angular.module('risevision.common.components', [
    'oc.lazyLoad'
  ]);

})(angular);
